import React from 'react';
import { S19Timeline, S19TimelineProps, MilanGradientColors, MilanBackgroundColors } from '@milanlaser/mlcomponents';
import {
    processBackgroundAndGradientColorMap,
    S19TimelineDataTypes,
    transformToS19TimelineData,
    useArrayKey,
} from '../../utils/builder.utils';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';

interface S19TimelineBuilderProps extends Omit<S19TimelineProps, 'timelineData'> {
    desktopPaddingTop?: PaddingSize;
    desktopPaddingBottom?: PaddingSize;
    mobilePaddingTop?: PaddingSize;
    mobilePaddingBottom?: PaddingSize;
    timelineData: S19TimelineDataTypes;
}

export function S19TimelineSection(props: S19TimelineBuilderProps) {
    const {
        desktopPaddingTop = 'large',
        desktopPaddingBottom = 'large',
        mobilePaddingTop = 'small',
        mobilePaddingBottom = 'small',
        ...restProps
    } = props;

    const timelineData = transformToS19TimelineData(restProps.timelineData);

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const modifiedProps = {
        ...restProps,
        backgroundColor: (restProps.backgroundColor || 'White') as MilanBackgroundColors,
        backgroundGradient: restProps.backgroundGradient as MilanGradientColors,
        className: `mcl-mx-auto mcl-max-w-7xl ${topPaddingClasses} ${bottomPaddingClasses}`,
    };

    const iconsKey = useArrayKey(timelineData.icons);

    const backgroundColor = processBackgroundAndGradientColorMap({
        backgroundColor: restProps.backgroundColor || 'default',
        gradientColor: restProps.backgroundGradient || 'default',
    });

    return (
        <div className={`${backgroundColor}`}>
            <S19Timeline key={iconsKey} {...modifiedProps} timelineData={timelineData} />
        </div>
    );
}
